export default __webpack_public_path__ + "static/media/article-placeholder.1db904a0.svg";